import React, { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Input,
  Row,
  Col,
} from "reactstrap";
import { useNotification } from "providers/NotificationProvider";
import userServices from "services/userServices";
import { useTranslation } from "context/TranslationProvider";
import { useAuth } from "context/AuthContext";

const FlaggedModal = ({ isOpen, toggle, contentCategory, contentId, user }) => {
  const { t } = useTranslation();
  const { notify } = useNotification();
  const { user: adminUser } = useAuth();

  const [context, setContext] = useState("");
  const [riskScore, setRiskScore] = useState(1);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!user?._id || !contentCategory || !contentId) {
      return notify(
        "error",
        t("page.flagged.errorMissingFields", "Missing required fields")
      );
    }

    setLoading(true);

    const payload = {
      userId: user._id,
      userName: `${user.firstName} ${user.lastName}`,
      contentCategory,
      contentId,
      context,
      riskScore,
      reviewedBy: adminUser?._id,
    };

    const result = await userServices.createFlaggedContent(payload);
    setLoading(false);

    if (result?.error) {
      notify("error", t(result.messageKey || result.error, result.message || t(result.error)));
    } else {
      notify(
        "success",
        t(result?.messageKey || "page.flagged.success", result?.message || t("page.flagged.success", "Content flagged successfully"))
      );
      const detail = { contentId: String(contentId) };
      window.dispatchEvent(new CustomEvent("moderationAction", { detail }));
      toggle();
      setContext("");
      setRiskScore(1);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      size="md"
      className="modal-dialog-centered"
    >
      <ModalHeader className="border" toggle={toggle}>
        {t("page.flagged.title", "Flag Content")}
      </ModalHeader>

      <ModalBody className="px-4 py-3">
        <Row className="mb-4">
          <Col>
            <small className="text-muted">
              {t("page.flagged.context", "Context / Reason")}
            </small>
            <Input
              type="textarea"
              rows="4"
              className="mt-2"
              value={context}
              onChange={(e) => setContext(e.target.value)}
              placeholder={t(
                "page.flagged.contextPlaceholder",
                "Describe why this content is flagged"
              )}
            />
          </Col>
        </Row>

        <Row className="mb-4">
          <Col md="6">
            <small className="text-muted">
              {t("page.flagged.riskScore", "Risk Score")}
            </small>
            <Input
              type="number"
              min={1}
              max={5}
              className="mt-2"
              value={riskScore}
              onChange={(e) => setRiskScore(Number(e.target.value))}
            />
          </Col>
        </Row>

        <div className="text-right mt-4">
          <Button
            color="secondary"
            onClick={toggle}
            disabled={loading}
          >
            {t("common.cancel", "Cancel")}
          </Button>

          <Button
            color="danger"
            className="ml-2"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading
              ? t("common.loading", "Loading....")
              : t("page.flagged.submit", "Flag")}
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default FlaggedModal;
